import request from '@/utils/request';

const swHead = '/api';

export const authService = {
  // 登录接口
  authLogin: (data) => request.post(`${swHead}/auth/login`, data),
  newLogin: (data) => request.post(`${swHead}/auth/newLogin`, data),
  googleLogin: (data) => request.post(`${swHead}/oauth/google-login`, data),

  // 用户是否存在
  authExist: (data) => request.get(`${swHead}/auth/exist/${data.email}`),
  // 发送邮箱获取验证码
  authEmailCode: (data) => request.post(`${swHead}/auth/email-verification-code`, data),
  // 注册接口
  authRegister: (data) => request.post(`${swHead}/auth/register`, data),
  // 修改密码
  authResetPassword: (data) => request.post(`${swHead}/auth/reset-password`, data),
  logout() {
    return request.post(`${swHead}/auth/logout`);
  },
};

export const infoController = {
  // 获取权益
  infoPlans: (data) => request.get(`${swHead}/info/plans`, data),
  // 付款
  checkout: (data) => request.post(`${swHead}/stripe/checkout`, data),
  // 查看订阅信息
  orderManage: (data) => request.post(`${swHead}/stripe/manage`, data),
  // 积分
  fuelBags: (data) => request.get(`${swHead}/info/fuel-bags`, data),
  // 积分消耗
  pointConsume: () => request.get(`${swHead}/point-consume`),
};

export const userService = {
  // 获取用户信息
  userDetail: (data) => request.get(`${swHead}/user/detail`, data),
  // 修改用户名称
  setNickname: (data) => request.post(`${swHead}/user/nickname`, data),
  // 修改用户头像
  setAvatar: (data) => request.post(`${swHead}/user/avatar`, data),
  // 提交用户问卷
  submitSurvey: (data) => request.post(`${swHead}/questionnaire`, data),
  // 查询用户是否填写问卷
  checkSurvey: () => request.get(`${swHead}/questionnaire`),
};

export const assetController = {
  // 获取资产列表
  assetsList: (data) => request.get(`${swHead}/asset`, data),
  // 删除
  delete: (data) => request.delete(`${swHead}/asset/${data.assetId}`),
  // 修改名称
  rename: (data) => request.post(`${swHead}/asset/${data.assetId}/name`, data.body),
  // 获取详情
  detail: (data) => request.get(`${swHead}/asset/${data.assetId}/detail`),
  //新增
  add: (data) => request.post(`${swHead}/asset`, data),
  // 导出列表
  exportList: () => request.get(`${swHead}/asset/exported`),
};

export const voiceController = {
  // 获取列表
  assetsList: (data) => request.get(`${swHead}/voice${data ? '/' + data : ''}`),
  rename: (data) => request.post(`${swHead}/voice/${data.voiceNum}/name`, data.body),
  // 删除
  delete: (data) => request.delete(`${swHead}/voice/${data.voiceNum}`),
  add: (data) => request.post(`${swHead}/voice`, data),
};

export const projectController = {
  // 获取列表
  list: (data) =>
    request.get(`${swHead}/project?pageIndex=${data.pageIndex}&pageSize=${data.pageSize}`),
  rename: (data) => request.post(`${swHead}/project/${data.projectId}/name`, data.body),
  delete: (data) => request.delete(`${swHead}/project/${data.projectId}`),
  detail: (data) => request.get(`${swHead}/project/${data.projectId}`),
  export: (data) => request.post(`${swHead}/project/${data.projectId}/export`, data.body),
  session: (data) => request.post(`${swHead}/project/${data.projectId}/session`),
  sentenceOp: (data) => request.post(`${swHead}/project/${data.projectId}/sentenceOp`, data.body),
  background: (data) => request.post(`${swHead}/project/${data.projectId}/background`, data.body),
  chooseVoice: (data) =>
    request.post(`${swHead}/project/${data.projectId}/choose-voice`, data.body),
  layout: (data) => request.post(`${swHead}/project/${data.projectId}/layout`, data.body),
  aspect: (data) => request.post(`${swHead}/project/${data.projectId}/aspect`, data.body),
  subtitleStyle: (data) =>
    request.post(`${swHead}/project/${data.projectId}/subtitleStyle`, data.body),
  subtitleBox: (data) => request.post(`${swHead}/project/${data.projectId}/subtitleBox`, data.body),
  exportProject: (data) => request.post(`${swHead}/project/${data.projectId}/export`, data.body),
  download: (data) => request.get(`${swHead}/project/${data.projectId}/download`),
  undo: (data) => request.post(`${swHead}/project/${data.projectId}/undo`, data.body),
  redo: (data) => request.post(`${swHead}/project/${data.projectId}/redo`, data.body),
  generateAll: (data) => request.post(`${swHead}/project/${data.projectId}/generateAll`, data.body),
  discardAll: (data) => request.post(`${swHead}/project/${data.projectId}/discardAll`, data.body),
  thumbnail: (data) => request.post(`${swHead}/project/${data.projectId}/thumbnail`, data.body),
  lipSync: (data) => request.get(`${swHead}/project/${data.projectId}/lipSync?value=${data.value}`),
  style: (data) => request.post(`${swHead}/style/${data.projectId}`, data.body),
  subtitleKey: (data) => request.post(`${swHead}/project/${data.projectId}/subtitleKey`, data.body),
  copyProject: (data) =>
    request.post(`${swHead}/project/${data.projectId}/translationCopy`, data.body),
  exportSubtitle: (data) =>
    request.post(`${swHead}/project/${data.projectId}/exportSubtitle`, data.body),
};

export const globalController = {
  preset: () => request.get(`${swHead}/info/preset`),
};

export const shareController = {
  // 根据id获取项目信息，针对分享者
  getDetailById: (id) => request.get(`${swHead}/share/${id}`),
  // 根据code获取项目信息，针对打开分享链接的用户
  getDetailByCode: (code) => request.get(`${swHead}/share/${code}/view`),
  // 获取视频下载视频
  preDownloadVideo: (id) => request.get(`${swHead}/project/${id}/pre-download`),
};

export const vidTranslation = {
  newUploadTask: (data) => request.post(`${swHead}/upload/task-translation`, data),
  translation: (data) => request.post(`${swHead}/project/`, data),
  heygenTranslation: (data) => request.post(`${swHead}/translation`, data),
  youtubeVideo: (data) => request.post(`${swHead}/translation/youtube-video`, data),
  youtubeDownloadAllowed: () => request.get(`${swHead}/info/youtubeDownloadAllowed`),
};

export const Space = {
  // 用户素材
  originalVideo: (data) =>
    request.get(
      `${swHead}/asset/original-video?pageIndex=${data.pageIndex}&pageSize=${data.pageSize}&type=${data.type}`,
    ),
  // 用户上传的音色
  userVoice: (data) =>
    request.get(`${swHead}/voice/user-clone?pageIndex=${data.pageIndex}&pageSize=${data.pageSize}`),
  // AI音色
  aiVoice: (data) =>
    request.get(`${swHead}/voice/ai?pageIndex=${data.pageIndex}&pageSize=${data.pageSize}`),
};
